/**
 * Created by laugh on 10/17/2017.
 */
export default function (state = "", action) {

    switch (action.type) {
        case 'ORDER_DATA':
            return action.setOrderData;
        default:
            return state
    }

}


// WEBPACK FOOTER //
// ./src/reducers/order-data.js